import { useState } from 'react';
import { usePolledData, type PolledData } from '@/lib/hooks/usePolledData';

/**
 * usePolledData whose cadence follows the latest data: `wantedInterval(data)` is re-evaluated each
 * render and the polling interval is adjusted (state set during render, the supported derive-state pattern).
 */
export function useAdaptivePolledData<T>(
  fetcher: () => Promise<T>,
  wantedInterval: (data: T | undefined) => number,
  initialInterval: number,
): PolledData<T> {
  const [interval, setIntervalMs] = useState(initialInterval);
  const polled = usePolledData(fetcher, interval);
  const wanted = wantedInterval(polled.data);
  if (wanted !== interval) setIntervalMs(wanted);
  return polled;
}
